<template>
  <b-row>
    <b-col>
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase"
            >Instrument Jig Configuration
          </span>
        </b-card-header>
        <b-card-body>
          <b-form-group label="Jig XYZ Data" label-cols="2">
            <b-row class="pr-3">
              <b-col class="pr-0">
                <b-input-group prepend="X">
                  <b-form-input
                    v-model.number="jig_x"
                    :state="!$v.jig_x.$invalid"
                    type="number"
                    invalid-feedback="Required"
                  />
                </b-input-group>
              </b-col>
              <b-col class="pr-0">
                <b-input-group prepend="Y">
                  <b-form-input
                    v-model.number="jig_y"
                    :state="!$v.jig_y.$invalid"
                    type="number"
                    invalid-feedback="Required"
                  />
                </b-input-group>
              </b-col>
              <b-col class="pr-0">
                <b-input-group prepend="Z">
                  <b-form-input
                    v-model.number="jig_z"
                    :state="!$v.jig_z.$invalid"
                    type="number"
                    invalid-feedback="Required"
                  />
                </b-input-group>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label="Jig Capacity" label-cols="2">
            <b-form-input
              v-model="jig_capacity"
              :state="!$v.jig_capacity.$invalid"
              disabled
              placeholder="Enter Jig Capacity"
              invalid-feedback="Required"
            />
            <div class="warning" v-if="capacity !== jig_capacity">
              {{ "Not matched with Instrument capacity." }}
            </div>
          </b-form-group>
          <b-form-group label="Jig Name" label-cols="2" class="mb-0">
            <b-form-input
              v-model="jig_name"
              :state="!$v.jig_name.$invalid"
              type="text"
              placeholder="Enter Jig Name"
              invalid-feedback="Required"
            />
          </b-form-group>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";

export default {
  name: "InstrumentJigForm",
  mixins: [validationMixin, ToastNotifications],
  props: {
    form_data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    jig_x: {
      get() {
        return this.form_data.jig_x;
      },
      set(value) {
        this.updateFormData(value, "jig_x");
      }
    },
    jig_y: {
      get() {
        return this.form_data.jig_y;
      },
      set(value) {
        this.updateFormData(value, "jig_y");
      }
    },
    jig_z: {
      get() {
        return this.form_data.jig_z;
      },
      set(value) {
        this.updateFormData(value, "jig_z");
      }
    },
    jig_name: {
      get() {
        return this.form_data.jig_name;
      },
      set(value) {
        this.updateFormData(value, "jig_name");
      }
    },
    capacity() {
      return this.form_data.capacity;
    },
    name() {
      return this.form_data.name;
    },
    jig_capacity() {
      const calculated_capacity = this.jig_x * this.jig_y * this.jig_z;
      this.updateFormData(calculated_capacity, "jig_capacity");
      return calculated_capacity;
    }
  },
  validations: {
    jig_name: { required },
    jig_capacity: { required },
    jig_x: { required },
    jig_y: { required },
    jig_z: { required }
  },
  methods: {
    updateFormData(value, field) {
      this.$emit("updateFormData", { value, field });
    }
  },
  mounted() {
    const calculated_name = `${
      this.name ? this.name : "Set Instrument Name"
    } Jig - ${this.jig_capacity}`;
    this.updateFormData(calculated_name, "jig_name");
  }
};
</script>

<style>
.error {
  color: #f86c6b;
  padding-top: 4px;
  font-size: 14px;
}
.warning {
  color: #ffc107;
  padding-top: 4px;
  font-size: 14px;
}
</style>
